import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { validateToken } from "./authUtils";

const AuthGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const valid = await validateToken();
      const userRole = localStorage.getItem("userRole");
      const currentStep = localStorage.getItem("currentStep");

      if (valid) {
        // If user is on '/' or '/loginPage', redirect and REPLACE history
        if (location.pathname === "/" || location.pathname.toLowerCase() === "/loginpage") {
          if (userRole === "crane") {
            navigate("/crane-driver-home", { replace: true });
          } else if (userRole === "customer") {         
            navigate("/customer-home-page", { replace: true });
          }
          else if (["Management", "IT", "Operations", "HR"].includes(userRole)) {
            navigate("/admin-dashboard-vendor-customer", { replace: true });
          }
          else if (userRole === "recoveryVan") {
            navigate("/crane-driver-home", { replace: true });
          }
          else if (userRole === "craneandrecoveryVan") {
            navigate("/crane-driver-home", { replace: true });
          }

          else if (userRole === "vendorDriver") {
            navigate("/vendor-driver-home", { replace: true });
          } else {
            navigate("/loginPage", { replace: true });
          }
        }
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("userRole");
        localStorage.removeItem("userId");

        // If not valid, only allow login or root
        if (location.pathname !== "/" && location.pathname.toLowerCase() !== "/loginpage") {
          navigate("/loginPage", { replace: true });
        }
      }

      setIsLoading(false);
    };

    checkAuth();
  }, []);

  if (isLoading) return null;

  return <Outlet />;
};

export default AuthGuard;

